export default __webpack_public_path__ + "static/media/PumaxBruna_06_1394_R1.785cfdc2.png";